import { Switch as ChakraSwitch } from "@chakra-ui/react"
import { forwardRef } from "react"

interface SwitchProps extends Omit<React.ComponentProps<typeof ChakraSwitch.Root>, 'children'> {
  children?: React.ReactNode
  size?: "xs" | "sm" | "md" | "lg"
  colorPalette?: "gray" | "red" | "orange" | "yellow" | "green" | "teal" | "blue" | "cyan" | "purple" | "pink"
  variant?: "outline" | "solid"
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraSwitch.Root {...props}>
        <ChakraSwitch.HiddenInput ref={ref} />
        <ChakraSwitch.Control 
          bg={{ base: 'gray.200', _dark: 'whiteAlpha.300' }}
          _checked={{ 
            bg: { base: `${props.colorPalette || 'blue'}.500`, _dark: `${props.colorPalette || 'blue'}.400` }
          }}
        >
          <ChakraSwitch.Thumb 
            bg={{ base: 'white', _dark: 'white' }}
            _checked={{ 
              bg: { base: 'white', _dark: 'white' }
            }}
          />
        </ChakraSwitch.Control>
        {children && <ChakraSwitch.Label>{children}</ChakraSwitch.Label>}
      </ChakraSwitch.Root>
    )
  }
)

Switch.displayName = "Switch"
